import {
  get_UrlProperties24r163uv67g3 as get_UrlProperties,
  decodeFromString1e1s881w515pe as decodeFromString,
  decodeFromStringMap1klpgj0m9fuhr as decodeFromStringMap,
  encodeToString2a3ryc7x3krzd as encodeToString,
  encodeToStringMap10nt8ix1o4hj8 as encodeToStringMap,
} from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/urls.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1i4e9ym37oxmo as serializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PayAppForm28kp0pq290pd9 as PayAppForm } from './components/project/work/payApps/PayAppForm.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ProjectLens2yr68t3q88g3j as ProjectLens,
  ProjectSectionusf1qp9zg3nc as ProjectSection,
  WorkSection1ye9ysnthnx95 as WorkSection,
  ProjectRouter1ifo7nf2si2jf as ProjectRouter,
} from './screens/common/ProjectView.mjs';
import { PayAppDetails12i3yidr5kt7h as PayAppDetails } from './components/project/work/payApps/PayAppDetails.mjs';
import { ChangeOrderForm23hgjlgmtvjevd as ChangeOrderForm2 } from './components/project/work/changeOrders/ChangeOrderForm2.mjs';
import { ChangeOrderDetails3bhfjfcpbf0qv as ChangeOrderDetails } from './components/project/work/changeOrders/mobile/ChangeOrderDetails.mjs';
import { ScopeViewDetailsf9xt7m1tnie as ScopeViewDetails } from './components/project/work/scope/ScopeViewDetails.mjs';
import { LineItemDetailsPage1m0bbf89e2gid as LineItemDetailsPage } from './components/project/work/scope/LineItemDetailsPage.mjs';
import { ProjectMessageThread3bzm1pe4dp4n as ProjectMessageThread } from './components/project/activity/messages.mjs';
import { ViewSettlementDocs1y21duy3panzg as ViewSettlementDocs } from './components/project/settlements/ViewSettlementDocs.mjs';
import { CreateProjectForm34kekzdlsbod1 as CreateProjectForm } from './screens/contractor/CreateProjectForm.mjs';
import {
  Section1t8b1ogi8i5xd as Section,
  EditProject1iovryfu514gb as EditProject,
} from './screens/contractor/EditProject.mjs';
import { ManageContractorUsers27kb1m7q8tkdk as ManageContractorUsers } from './screens/contractor/ManageContractorUsers.mjs';
import { ContractorProjects2hltgp2s6pm9i as ContractorProjects } from './screens/contractor/ContractorProjects.mjs';
import {
  ContractorPayments3j77ex8prycqi as ContractorPayments,
  Section14eh2zqy1zxno as Section_0,
} from './screens/contractor/ContractorPayments.mjs';
import { CreateProject30799kzrue0ed as CreateProject } from './screens/contractor/CreateProject.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from './screens/contractor/ContractorProject.mjs';
import { Specifications3c29ii5k9j2f7 as Specifications } from './screens/contractor/Specifications.mjs';
import { ContractorDashboardpd20b7ol1l5h as ContractorDashboard } from './screens/contractor/ContractorDashboard.mjs';
import { ContractorClientsflh7jhpyocdp as ContractorClients } from './screens/contractor/ContractorClients.mjs';
import { ContractorProfilenrafjpe3uo0b as ContractorProfile } from './screens/contractor/ContractorProfile.mjs';
import { ContractorBillingInfos14ebalmoocx as ContractorBillingInfo } from './screens/contractor/ContractorBillingInfo.mjs';
import { ContractorBankInfo3chkr569ztcs7 as ContractorBankInfo } from './screens/contractor/ContractorBankInfo.mjs';
import { ContractorNewRegistration1u860bdbb1seh as ContractorNewRegistration } from './screens/auth/NewContractorRegistration.mjs';
import { LogInScreen3qovz4fzwtjwv as LogInScreen } from './screens/auth/LogInScreen.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { UserRegistration2mhykjk2xa45 as UserRegistration } from './screens/auth/UserRegistration.mjs';
import { PaymentSetup1pjaa9mt31519 as PaymentSetup } from './screens/auth/PaymentSetup.mjs';
import { UserProfile2tyxfth4oycef as UserProfile } from './screens/auth/UserProfile.mjs';
import { ClientPayments2dnqnm01pn8b5 as ClientPayments } from './screens/client/ClientPayments.mjs';
import { ClientProject3d3kef0q1hn13 as ClientProject } from './screens/client/ClientProject.mjs';
import { ClientProjectsuhqipbst20fz as ClientProjects } from './screens/client/ClientProjects.mjs';
import { ClientTermsAndServicesuocndg7xpxyw as ClientTermsAndServices } from './screens/client/ClientTermsAndServices.mjs';
import { ClientDashboard2uxyaz2oxv2st as ClientDashboard } from './screens/client/ClientDashboard.mjs';
import { AdminExternalDepositPage3utp9dihxm4p as AdminExternalDepositPage } from './screens/admin/AdminExternalDepositPage.mjs';
import { AdminReportingPage2yeyg5apo8s8x as AdminReportingPage } from './screens/admin/AdminReportingPage.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { State3dw676r1r3e8w as State } from '../../../../crowpay-shared/com/crowpay/enums.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import {
  DevProjectViewbz7mvcn13n05 as DevProjectView,
  SelectDevProjectScreenktpl27uiowry as SelectDevProjectScreen,
} from './screens/common/DevProjectView.mjs';
import { JumpTo1euh8ix4kcm68 as JumpTo } from '../../../../crowpay-shared/com/crowpay/URLs.mjs';
import { MessagingScreen3v4v784hye3oc as MessagingScreen } from './screens/common/MessagingScreen.mjs';
import {
  ContractorWorkLists2gwrvh4dcfppr as ContractorWorkLists,
  ClientWorkListsm2d5ivw4fy3k as ClientWorkLists,
} from './screens/common/WorkListsScreen.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from './screens/common/LandingScreen.mjs';
import {
  ClientNotificationSettings1m4d3pbyj6bl9 as ClientNotificationSettings,
  ContractorNotificationSettings1wc9spupzmetl as ContractorNotificationSettings,
} from './screens/common/NotificationSubscriptionSettings.mjs';
import { AnonymousProjectView24hg9uw1el0c2 as AnonymousProjectView } from './screens/common/AnonymousProjectView.mjs';
import { Typeqwc7utefu20x as Type } from '../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { ViewLegalDocument2rrxowcqg42d as ViewLegalDocument } from './screens/common/ViewLegalDocument.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  UrlLikePath1l4lcedbwd0yq as UrlLikePath,
  RouteRendered1fij9e8c6nzoq as RouteRendered,
  Routesboifombvgcz7 as Routes,
} from '../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  FourOhFour2zwj647snm4n2 as FourOhFour,
  FourOhFour_instance1sei8oq9p2wtd as FourOhFour_instance,
} from './screens/common/FourOhFour.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_AutoRoutes() {
  _init_properties_autoroutes_kt__az6i9l();
  return AutoRoutes;
}
var AutoRoutes;
function AutoRoutes$lambda(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 3))
    return null;
  if (!(it.sbw_1.q1(0) === 'draws'))
    return null;
  if (!(it.sbw_1.q1(2) === 'edit'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  return new (PayAppForm())(tmp$ret$2);
}
function AutoRoutes$lambda_0(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 5))
    return null;
  if (!(it.sbw_1.q1(0) === 'projects'))
    return null;
  if (!(it.sbw_1.q1(2) === 'draws'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = decodeFromString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_0 = it.sbw_1.q1(3);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp_0 = decodeFromString(tmp0_0, tmp$ret$4, value_0);
  var tmp0_1 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_1 = it.sbw_1.q1(4);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = tmp0_1.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  var tmp$ret$8 = decodeFromString(tmp0_1, tmp$ret$7, value_1);
  // Inline function 'kotlin.apply' call
  return new (PayAppDetails())(tmp, tmp_0, tmp$ret$8);
}
function AutoRoutes$lambda_1(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 5))
    return null;
  if (!(it.sbw_1.q1(0) === 'project'))
    return null;
  if (!(it.sbw_1.q1(2) === 'change'))
    return null;
  if (!(it.sbw_1.q1(4) === 'edit'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = decodeFromString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_0 = it.sbw_1.q1(3);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = decodeFromString(tmp0_0, tmp$ret$4, value_0);
  // Inline function 'kotlin.apply' call
  return new (ChangeOrderForm2())(tmp, tmp$ret$5);
}
function AutoRoutes$lambda_2(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 5))
    return null;
  if (!(it.sbw_1.q1(0) === 'project'))
    return null;
  if (!(it.sbw_1.q1(2) === 'change'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = decodeFromString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_0 = it.sbw_1.q1(3);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp_0 = decodeFromString(tmp0_0, tmp$ret$4, value_0);
  var tmp0_1 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_1 = it.sbw_1.q1(4);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = tmp0_1.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  var tmp$ret$8 = decodeFromString(tmp0_1, tmp$ret$7, value_1);
  // Inline function 'kotlin.apply' call
  return new (ChangeOrderDetails())(tmp, tmp_0, tmp$ret$8);
}
function AutoRoutes$lambda_3(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 5))
    return null;
  if (!(it.sbw_1.q1(0) === 'project'))
    return null;
  if (!(it.sbw_1.q1(2) === 'scope'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = decodeFromString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_0 = it.sbw_1.q1(3);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp_0 = decodeFromString(tmp0_0, tmp$ret$4, value_0);
  var tmp0_1 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_1 = it.sbw_1.q1(4);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = tmp0_1.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  var tmp$ret$8 = decodeFromString(tmp0_1, tmp$ret$7, value_1);
  // Inline function 'kotlin.apply' call
  return new (ScopeViewDetails())(tmp, tmp_0, tmp$ret$8);
}
function AutoRoutes$lambda_4(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 5))
    return null;
  if (!(it.sbw_1.q1(0) === 'project'))
    return null;
  if (!(it.sbw_1.q1(2) === 'work-item'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = decodeFromString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_0 = it.sbw_1.q1(3);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp_0 = decodeFromString(tmp0_0, tmp$ret$4, value_0);
  var tmp0_1 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_1 = it.sbw_1.q1(4);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = tmp0_1.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  var tmp$ret$8 = decodeFromString(tmp0_1, tmp$ret$7, value_1);
  // Inline function 'kotlin.apply' call
  return new (LineItemDetailsPage())(tmp, tmp_0, tmp$ret$8);
}
function AutoRoutes$lambda_5(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 4))
    return null;
  if (!(it.sbw_1.q1(0) === 'project'))
    return null;
  if (!(it.sbw_1.q1(1) === 'messages'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(2);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = decodeFromString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_0 = it.sbw_1.q1(3);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = decodeFromString(tmp0_0, tmp$ret$4, value_0);
  // Inline function 'kotlin.apply' call
  return new (ProjectMessageThread())(tmp, tmp$ret$5);
}
function AutoRoutes$lambda_6(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 4))
    return null;
  if (!(it.sbw_1.q1(0) === 'projects'))
    return null;
  if (!(it.sbw_1.q1(3) === 'settlements'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = decodeFromString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value_0 = it.sbw_1.q1(2);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = decodeFromString(tmp0_0, tmp$ret$4, value_0);
  // Inline function 'kotlin.apply' call
  return new (ViewSettlementDocs())(tmp, tmp$ret$5);
}
function AutoRoutes$lambda_7(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 4))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'project'))
    return null;
  if (!(it.sbw_1.q1(3) === 'create'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(2);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  var this_2 = new (CreateProjectForm())(tmp$ret$2);
  var tmp0_0 = get_UrlProperties();
  var tmp2 = 'selectedTab';
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_2.tes_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(getKClass(Section()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0_0, tmp$ret$4, tmp2, tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_2;
}
function AutoRoutes$lambda_8(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'users'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ManageContractorUsers())();
}
function AutoRoutes$lambda_9(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'projects'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ContractorProjects())();
}
function AutoRoutes$lambda_10(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 4))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'project'))
    return null;
  if (!(it.sbw_1.q1(3) === 'edit'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(2);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  var this_2 = new (EditProject())(tmp$ret$2);
  var tmp0_0 = get_UrlProperties();
  var tmp2 = 'selectedTab';
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_2.xes_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(getKClass(Section()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0_0, tmp$ret$4, tmp2, tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_2;
}
function AutoRoutes$lambda_11(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'payments'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (ContractorPayments())();
  var tmp0 = get_UrlProperties();
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_0.let_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer(this_1, createKType(getKClass(Section_0()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0, tmp$ret$1, 'section', tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_0;
}
function AutoRoutes$lambda_12(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 3))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'project'))
    return null;
  if (!(it.sbw_1.q1(2) === 'create'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (CreateProject())();
}
function AutoRoutes$lambda_13(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 3))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'projects'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(2);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  var this_2 = new (ContractorProject())(tmp$ret$2);
  var tmp0_0 = get_UrlProperties();
  var tmp2 = 'viewingSection';
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_2.dev();
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(getKClass(ProjectSection()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0_0, tmp$ret$4, tmp2, tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_2;
}
function AutoRoutes$lambda_14(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'specifications'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (Specifications())();
}
function AutoRoutes$lambda_15(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 1))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ContractorDashboard())();
}
function AutoRoutes$lambda_16(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'clients'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ContractorClients())();
}
function AutoRoutes$lambda_17(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'profile'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ContractorProfile())();
}
function AutoRoutes$lambda_18(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'billing'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ContractorBillingInfo())();
}
function AutoRoutes$lambda_19(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'bank-info'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ContractorBankInfo())();
}
function AutoRoutes$lambda_20(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'register'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ContractorNewRegistration())();
}
function AutoRoutes$lambda_21(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'auth'))
    return null;
  if (!(it.sbw_1.q1(1) === 'log-in'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (LogInScreen())();
  var tmp0 = get_UrlProperties();
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_0.eev_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0, tmp$ret$1, 'next', tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  var tmp0_0 = get_UrlProperties();
  var tmp2 = 'registering';
  var tmp4_0 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_0 = this_0.jev_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().yf(), arrayOf([]), false));
  var tmp$ret$6 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp0_safe_receiver_0 = decodeFromStringMap(tmp0_0, tmp$ret$6, tmp2, tmp4_0);
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_0.eak(tmp0_safe_receiver_0);
  }
  return this_0;
}
function AutoRoutes$lambda_22(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'auth'))
    return null;
  if (!(it.sbw_1.q1(1) === 'user-registration'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (UserRegistration())();
  var tmp0 = get_UrlProperties();
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_0.lev_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0, tmp$ret$1, 'next', tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_0;
}
function AutoRoutes$lambda_23(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'auth'))
    return null;
  if (!(it.sbw_1.q1(1) === 'payment-setup'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (PaymentSetup())();
  var tmp0 = get_UrlProperties();
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_0.tev_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0, tmp$ret$1, 'next', tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_0;
}
function AutoRoutes$lambda_24(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'user'))
    return null;
  if (!(it.sbw_1.q1(1) === 'profile'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (UserProfile())();
}
function AutoRoutes$lambda_25(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'client'))
    return null;
  if (!(it.sbw_1.q1(1) === 'payments'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ClientPayments())();
}
function AutoRoutes$lambda_26(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 3))
    return null;
  if (!(it.sbw_1.q1(0) === 'client'))
    return null;
  if (!(it.sbw_1.q1(1) === 'projects'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(2);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  var this_2 = new (ClientProject())(tmp$ret$2);
  var tmp0_0 = get_UrlProperties();
  var tmp2 = 'viewingSection';
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_2.dev();
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(getKClass(ProjectSection()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0_0, tmp$ret$4, tmp2, tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_2;
}
function AutoRoutes$lambda_27(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'client'))
    return null;
  if (!(it.sbw_1.q1(1) === 'projects'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ClientProjects())();
}
function AutoRoutes$lambda_28(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 3))
    return null;
  if (!(it.sbw_1.q1(0) === 'client'))
    return null;
  if (!(it.sbw_1.q1(1) === 'accept-project'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(2);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  return new (ClientTermsAndServices())(tmp$ret$2);
}
function AutoRoutes$lambda_29(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 1))
    return null;
  if (!(it.sbw_1.q1(0) === 'client'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ClientDashboard())();
}
function AutoRoutes$lambda_30(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'admin'))
    return null;
  if (!(it.sbw_1.q1(1) === 'deposit'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (AdminExternalDepositPage())();
  var tmp0 = get_UrlProperties();
  var tmp2 = 'projectReference';
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_0.nex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0, tmp$ret$1, tmp2, tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_0;
}
function AutoRoutes$lambda_31(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'admin'))
    return null;
  if (!(it.sbw_1.q1(1) === 'reports'))
    return null;
  // Inline function 'kotlin.apply' call
  var this_0 = new (AdminReportingPage())();
  var tmp0 = get_UrlProperties();
  var tmp2 = 'periodAllowedStates';
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_0.yex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer(this_1, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(State()), arrayOf([]), false))]), true));
  var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0, tmp$ret$1, tmp2, tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  var tmp0_0 = get_UrlProperties();
  var tmp2_0 = 'snapshotAllowedStates';
  var tmp4_0 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_0 = this_0.rex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(State()), arrayOf([]), false))]), true));
  var tmp$ret$6 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp0_safe_receiver_0 = decodeFromStringMap(tmp0_0, tmp$ret$6, tmp2_0, tmp4_0);
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_0.eak(tmp0_safe_receiver_0);
  }
  var tmp0_1 = get_UrlProperties();
  var tmp2_1 = 'snapshotAllowedProjects';
  var tmp4_1 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_1 = this_0.pex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_5 = tmp0_1.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_6 = serializer(this_5, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$11 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
  var tmp0_safe_receiver_1 = decodeFromStringMap(tmp0_1, tmp$ret$11, tmp2_1, tmp4_1);
  if (tmp0_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_1.eak(tmp0_safe_receiver_1);
  }
  var tmp0_2 = get_UrlProperties();
  var tmp2_2 = 'homeownerStates';
  var tmp4_2 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_2 = this_0.cey_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_7 = tmp0_2.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_8 = serializer(this_7, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(State()), arrayOf([]), false))]), true));
  var tmp$ret$16 = isInterface(this_8, KSerializer()) ? this_8 : THROW_CCE();
  var tmp0_safe_receiver_2 = decodeFromStringMap(tmp0_2, tmp$ret$16, tmp2_2, tmp4_2);
  if (tmp0_safe_receiver_2 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_2.eak(tmp0_safe_receiver_2);
  }
  var tmp0_3 = get_UrlProperties();
  var tmp2_3 = 'homeownerUsers';
  var tmp4_3 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_3 = this_0.aey_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_9 = tmp0_3.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_10 = serializer(this_9, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$21 = isInterface(this_10, KSerializer()) ? this_10 : THROW_CCE();
  var tmp0_safe_receiver_3 = decodeFromStringMap(tmp0_3, tmp$ret$21, tmp2_3, tmp4_3);
  if (tmp0_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_3.eak(tmp0_safe_receiver_3);
  }
  var tmp0_4 = get_UrlProperties();
  var tmp2_4 = 'periodAllowedProjects';
  var tmp4_4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_4 = this_0.wex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_11 = tmp0_4.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_12 = serializer(this_11, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$26 = isInterface(this_12, KSerializer()) ? this_12 : THROW_CCE();
  var tmp0_safe_receiver_4 = decodeFromStringMap(tmp0_4, tmp$ret$26, tmp2_4, tmp4_4);
  if (tmp0_safe_receiver_4 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_4.eak(tmp0_safe_receiver_4);
  }
  var tmp0_5 = get_UrlProperties();
  var tmp2_5 = 'periodEndTime';
  var tmp4_5 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_5 = this_0.vex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_13 = tmp0_5.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_14 = serializer(this_13, createKType(getKClass(Instant()), arrayOf([]), false));
  var tmp$ret$31 = isInterface(this_14, KSerializer()) ? this_14 : THROW_CCE();
  var tmp0_safe_receiver_5 = decodeFromStringMap(tmp0_5, tmp$ret$31, tmp2_5, tmp4_5);
  if (tmp0_safe_receiver_5 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_5.eak(tmp0_safe_receiver_5);
  }
  var tmp0_6 = get_UrlProperties();
  var tmp2_6 = 'snapshotAt';
  var tmp4_6 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_6 = this_0.oex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_15 = tmp0_6.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_16 = serializer(this_15, createKType(getKClass(Instant()), arrayOf([]), false));
  var tmp$ret$36 = isInterface(this_16, KSerializer()) ? this_16 : THROW_CCE();
  var tmp0_safe_receiver_6 = decodeFromStringMap(tmp0_6, tmp$ret$36, tmp2_6, tmp4_6);
  if (tmp0_safe_receiver_6 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_6.eak(tmp0_safe_receiver_6);
  }
  var tmp0_7 = get_UrlProperties();
  var tmp2_7 = 'snapshotAllowedContractors';
  var tmp4_7 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_7 = this_0.qex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_17 = tmp0_7.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_18 = serializer(this_17, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$41 = isInterface(this_18, KSerializer()) ? this_18 : THROW_CCE();
  var tmp0_safe_receiver_7 = decodeFromStringMap(tmp0_7, tmp$ret$41, tmp2_7, tmp4_7);
  if (tmp0_safe_receiver_7 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_7.eak(tmp0_safe_receiver_7);
  }
  var tmp0_8 = get_UrlProperties();
  var tmp2_8 = 'homeownerProjects';
  var tmp4_8 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_8 = this_0.bey_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_19 = tmp0_8.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_20 = serializer(this_19, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$46 = isInterface(this_20, KSerializer()) ? this_20 : THROW_CCE();
  var tmp0_safe_receiver_8 = decodeFromStringMap(tmp0_8, tmp$ret$46, tmp2_8, tmp4_8);
  if (tmp0_safe_receiver_8 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_8.eak(tmp0_safe_receiver_8);
  }
  var tmp0_9 = get_UrlProperties();
  var tmp2_9 = 'periodStartTime';
  var tmp4_9 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_9 = this_0.uex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_21 = tmp0_9.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_22 = serializer(this_21, createKType(getKClass(Instant()), arrayOf([]), false));
  var tmp$ret$51 = isInterface(this_22, KSerializer()) ? this_22 : THROW_CCE();
  var tmp0_safe_receiver_9 = decodeFromStringMap(tmp0_9, tmp$ret$51, tmp2_9, tmp4_9);
  if (tmp0_safe_receiver_9 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_9.eak(tmp0_safe_receiver_9);
  }
  var tmp0_10 = get_UrlProperties();
  var tmp2_10 = 'periodAllowedContractors';
  var tmp4_10 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_10 = this_0.xex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_23 = tmp0_10.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_24 = serializer(this_23, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$56 = isInterface(this_24, KSerializer()) ? this_24 : THROW_CCE();
  var tmp0_safe_receiver_10 = decodeFromStringMap(tmp0_10, tmp$ret$56, tmp2_10, tmp4_10);
  if (tmp0_safe_receiver_10 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_10.eak(tmp0_safe_receiver_10);
  }
  var tmp0_11 = get_UrlProperties();
  var tmp2_11 = 'homeownerAt';
  var tmp4_11 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into_11 = this_0.zex_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_25 = tmp0_11.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_26 = serializer(this_25, createKType(getKClass(Instant()), arrayOf([]), false));
  var tmp$ret$61 = isInterface(this_26, KSerializer()) ? this_26 : THROW_CCE();
  var tmp0_safe_receiver_11 = decodeFromStringMap(tmp0_11, tmp$ret$61, tmp2_11, tmp4_11);
  if (tmp0_safe_receiver_11 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into_11.eak(tmp0_safe_receiver_11);
  }
  return this_0;
}
function AutoRoutes$lambda_32(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'dev-project'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  var this_2 = new (DevProjectView())(tmp$ret$2);
  var tmp0_0 = get_UrlProperties();
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_2.key_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(getKClass(WorkSection()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0_0, tmp$ret$4, 'tab', tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_2;
}
function AutoRoutes$lambda_33(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 1))
    return null;
  if (!(it.sbw_1.q1(0) === 'select-dev-project'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (SelectDevProjectScreen())();
}
function AutoRoutes$lambda_34(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'projects'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  var this_2 = new (ProjectRouter())(tmp$ret$2);
  var tmp0_0 = get_UrlProperties();
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_2.tez_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(getKClass(JumpTo()), arrayOf([]), true));
  var tmp$ret$4 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0_0, tmp$ret$4, 'jumpto', tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_2;
}
function AutoRoutes$lambda_35(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'messages'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  return new (MessagingScreen())(tmp$ret$2);
}
function AutoRoutes$lambda_36(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'tasks'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ContractorWorkLists())();
}
function AutoRoutes$lambda_37(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'client'))
    return null;
  if (!(it.sbw_1.q1(1) === 'tasks'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ClientWorkLists())();
}
function AutoRoutes$lambda_38(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 0))
    return null;
  // Inline function 'kotlin.apply' call
  return new (LandingScreen())();
}
function AutoRoutes$lambda_39(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'client'))
    return null;
  if (!(it.sbw_1.q1(1) === 'notifications'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ClientNotificationSettings())();
}
function AutoRoutes$lambda_40(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'contractor'))
    return null;
  if (!(it.sbw_1.q1(1) === 'notifications'))
    return null;
  // Inline function 'kotlin.apply' call
  return new (ContractorNotificationSettings())();
}
function AutoRoutes$lambda_41(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 3))
    return null;
  if (!(it.sbw_1.q1(0) === 'anonymous'))
    return null;
  if (!(it.sbw_1.q1(1) === 'projects'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(2);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  var this_2 = new (AnonymousProjectView())(tmp$ret$2);
  var tmp0_0 = get_UrlProperties();
  var tmp4 = it.tbw_1;
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromStringMap' call
  var into = this_2.mf1_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp0_safe_receiver = decodeFromStringMap(tmp0_0, tmp$ret$4, 'server', tmp4);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    into.eak(tmp0_safe_receiver);
  }
  return this_2;
}
function AutoRoutes$lambda_42(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it.sbw_1.p1() === 2))
    return null;
  if (!(it.sbw_1.q1(0) === 'documents'))
    return null;
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.decodeFromString' call
  var value = it.sbw_1.q1(1);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(Type()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = decodeFromString(tmp0, tmp$ret$1, value);
  // Inline function 'kotlin.apply' call
  return new (ViewLegalDocument())(tmp$ret$2);
}
function AutoRoutes$lambda_43(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof PayAppForm()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.qf2_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = encodeToString(tmp0, tmp$ret$1, value);
  var tmp = new (UrlLikePath())(listOf(['draws', tmp$ret$2, 'edit']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$3 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$3);
}
function AutoRoutes$lambda_44(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof PayAppDetails()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.nf3_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = encodeToString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.of3_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp_0 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  var tmp0_1 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_1 = it.pf3_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = tmp0_1.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  var tmp$ret$8 = encodeToString(tmp0_1, tmp$ret$7, value_1);
  var tmp_1 = new (UrlLikePath())(listOf(['projects', tmp, 'draws', tmp_0, tmp$ret$8]), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_45(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ChangeOrderForm2()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.yf3_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = encodeToString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.zf3_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  var tmp_0 = new (UrlLikePath())(listOf(['project', tmp, 'change', tmp$ret$5, 'edit']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_0, tmp$ret$6);
}
function AutoRoutes$lambda_46(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ChangeOrderDetails()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.sf4_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = encodeToString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.tf4_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp_0 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  var tmp0_1 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_1 = it.uf4_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = tmp0_1.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  var tmp$ret$8 = encodeToString(tmp0_1, tmp$ret$7, value_1);
  var tmp_1 = new (UrlLikePath())(listOf(['project', tmp, 'change', tmp_0, tmp$ret$8]), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_47(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ScopeViewDetails()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.ff5_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = encodeToString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.gf5_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp_0 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  var tmp0_1 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_1 = it.hf5_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = tmp0_1.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  var tmp$ret$8 = encodeToString(tmp0_1, tmp$ret$7, value_1);
  var tmp_1 = new (UrlLikePath())(listOf(['project', tmp, 'scope', tmp_0, tmp$ret$8]), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_48(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof LineItemDetailsPage()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.yf5_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = encodeToString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.zf5_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp_0 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  var tmp0_1 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_1 = it.af6_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = tmp0_1.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  var tmp$ret$8 = encodeToString(tmp0_1, tmp$ret$7, value_1);
  var tmp_1 = new (UrlLikePath())(listOf(['project', tmp, 'work-item', tmp_0, tmp$ret$8]), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$9 = emptyList();
  return new (RouteRendered())(tmp_1, tmp$ret$9);
}
function AutoRoutes$lambda_49(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ProjectMessageThread()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.nf6_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = encodeToString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.of6_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  var tmp_0 = new (UrlLikePath())(listOf(['project', 'messages', tmp, tmp$ret$5]), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_0, tmp$ret$6);
}
function AutoRoutes$lambda_50(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ViewSettlementDocs()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.rf6_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp = encodeToString(tmp0, tmp$ret$1, value);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.sf6_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  var tmp_0 = new (UrlLikePath())(listOf(['projects', tmp, tmp$ret$5, 'settlements']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$6 = emptyList();
  return new (RouteRendered())(tmp_0, tmp$ret$6);
}
function AutoRoutes$lambda_51(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof CreateProjectForm()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  var tmp2 = ReactiveState__getOrNull_impl_1asnfp(it.tes_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key = 'selectedTab';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(Section()), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, tmp2, key, p);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.ses_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['contractor', 'project', tmp$ret$5, 'create']), p), listOf_0(it.tes_1));
}
function AutoRoutes$lambda_52(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ManageContractorUsers()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'users']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_53(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorProjects()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'projects']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_54(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof EditProject()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  var tmp2 = ReactiveState__getOrNull_impl_1asnfp(it.xes_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key = 'selectedTab';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(Section()), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, tmp2, key, p);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.wes_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['contractor', 'project', tmp$ret$5, 'edit']), p), listOf_0(it.xes_1));
}
function AutoRoutes$lambda_55(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorPayments()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var value = ReactiveState__getOrNull_impl_1asnfp(it.let_1.sah());
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(Section_0()), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, value, 'section', p);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['contractor', 'payments']), p), listOf_0(it.let_1));
}
function AutoRoutes$lambda_56(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof CreateProject()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'project', 'create']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_57(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorProject()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  var tmp2 = ReactiveState__getOrNull_impl_1asnfp(it.dev().sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key = 'viewingSection';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ProjectSection()), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, tmp2, key, p);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.lf8();
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['contractor', 'projects', tmp$ret$5]), p), listOf_0(it.dev()));
}
function AutoRoutes$lambda_58(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof Specifications()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'specifications']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_59(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorDashboard()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf_0('contractor'), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_60(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorClients()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'clients']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_61(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorProfile()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'profile']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_62(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorBillingInfo()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'billing']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_63(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorBankInfo()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'bank-info']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_64(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorNewRegistration()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'register']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_65(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof LogInScreen()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var value = ReactiveState__getOrNull_impl_1asnfp(it.eev_1.sah());
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, value, 'next', p);
  var tmp0_0 = get_UrlProperties();
  var tmp2 = ReactiveState__getOrNull_impl_1asnfp(it.jev_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key = 'registering';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(PrimitiveClasses_getInstance().yf(), arrayOf([]), true));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  encodeToStringMap(tmp0_0, tmp$ret$4, tmp2, key, p);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['auth', 'log-in']), p), listOf([it.eev_1, it.jev_1]));
}
function AutoRoutes$lambda_66(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof UserRegistration()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var value = ReactiveState__getOrNull_impl_1asnfp(it.lev_1.sah());
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, value, 'next', p);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['auth', 'user-registration']), p), listOf_0(it.lev_1));
}
function AutoRoutes$lambda_67(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof PaymentSetup()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var value = ReactiveState__getOrNull_impl_1asnfp(it.tev_1.sah());
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, value, 'next', p);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['auth', 'payment-setup']), p), listOf_0(it.tev_1));
}
function AutoRoutes$lambda_68(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof UserProfile()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['user', 'profile']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_69(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ClientPayments()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['client', 'payments']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_70(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ClientProject()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  var tmp2 = ReactiveState__getOrNull_impl_1asnfp(it.dev().sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key = 'viewingSection';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ProjectSection()), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, tmp2, key, p);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.lf8();
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['client', 'projects', tmp$ret$5]), p), listOf_0(it.dev()));
}
function AutoRoutes$lambda_71(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ClientProjects()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['client', 'projects']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_72(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ClientTermsAndServices()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.mf8_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = encodeToString(tmp0, tmp$ret$1, value);
  var tmp = new (UrlLikePath())(listOf(['client', 'accept-project', tmp$ret$2]), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$3 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$3);
}
function AutoRoutes$lambda_73(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ClientDashboard()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf_0('client'), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_74(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof AdminExternalDepositPage()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  var tmp2 = ReactiveState__getOrNull_impl_1asnfp(it.nex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key = 'projectReference';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, tmp2, key, p);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['admin', 'deposit']), p), listOf_0(it.nex_1));
}
function AutoRoutes$lambda_75(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof AdminReportingPage()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  var tmp2 = ReactiveState__getOrNull_impl_1asnfp(it.yex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key = 'periodAllowedStates';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(State()), arrayOf([]), false))]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, tmp2, key, p);
  var tmp0_0 = get_UrlProperties();
  var tmp2_0 = ReactiveState__getOrNull_impl_1asnfp(it.rex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_0 = 'snapshotAllowedStates';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(State()), arrayOf([]), false))]), true));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  encodeToStringMap(tmp0_0, tmp$ret$4, tmp2_0, key_0, p);
  var tmp0_1 = get_UrlProperties();
  var tmp2_1 = ReactiveState__getOrNull_impl_1asnfp(it.pex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_1 = 'snapshotAllowedProjects';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$7 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  encodeToStringMap(tmp0_1, tmp$ret$7, tmp2_1, key_1, p);
  var tmp0_2 = get_UrlProperties();
  var tmp2_2 = ReactiveState__getOrNull_impl_1asnfp(it.cey_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_2 = 'homeownerStates';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_6 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_7 = serializer(this_6, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(State()), arrayOf([]), false))]), true));
  var tmp$ret$10 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
  encodeToStringMap(tmp0_2, tmp$ret$10, tmp2_2, key_2, p);
  var tmp0_3 = get_UrlProperties();
  var tmp2_3 = ReactiveState__getOrNull_impl_1asnfp(it.aey_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_3 = 'homeownerUsers';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_8 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_9 = serializer(this_8, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$13 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
  encodeToStringMap(tmp0_3, tmp$ret$13, tmp2_3, key_3, p);
  var tmp0_4 = get_UrlProperties();
  var tmp2_4 = ReactiveState__getOrNull_impl_1asnfp(it.wex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_4 = 'periodAllowedProjects';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_10 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_11 = serializer(this_10, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$16 = isInterface(this_11, KSerializer()) ? this_11 : THROW_CCE();
  encodeToStringMap(tmp0_4, tmp$ret$16, tmp2_4, key_4, p);
  var tmp0_5 = get_UrlProperties();
  var tmp2_5 = ReactiveState__getOrNull_impl_1asnfp(it.vex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_5 = 'periodEndTime';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_12 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_13 = serializer(this_12, createKType(getKClass(Instant()), arrayOf([]), true));
  var tmp$ret$19 = isInterface(this_13, KSerializer()) ? this_13 : THROW_CCE();
  encodeToStringMap(tmp0_5, tmp$ret$19, tmp2_5, key_5, p);
  var tmp0_6 = get_UrlProperties();
  var tmp2_6 = ReactiveState__getOrNull_impl_1asnfp(it.oex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_6 = 'snapshotAt';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_14 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_15 = serializer(this_14, createKType(getKClass(Instant()), arrayOf([]), true));
  var tmp$ret$22 = isInterface(this_15, KSerializer()) ? this_15 : THROW_CCE();
  encodeToStringMap(tmp0_6, tmp$ret$22, tmp2_6, key_6, p);
  var tmp0_7 = get_UrlProperties();
  var tmp2_7 = ReactiveState__getOrNull_impl_1asnfp(it.qex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_7 = 'snapshotAllowedContractors';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_16 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_17 = serializer(this_16, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$25 = isInterface(this_17, KSerializer()) ? this_17 : THROW_CCE();
  encodeToStringMap(tmp0_7, tmp$ret$25, tmp2_7, key_7, p);
  var tmp0_8 = get_UrlProperties();
  var tmp2_8 = ReactiveState__getOrNull_impl_1asnfp(it.bey_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_8 = 'homeownerProjects';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_18 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_19 = serializer(this_18, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$28 = isInterface(this_19, KSerializer()) ? this_19 : THROW_CCE();
  encodeToStringMap(tmp0_8, tmp$ret$28, tmp2_8, key_8, p);
  var tmp0_9 = get_UrlProperties();
  var tmp2_9 = ReactiveState__getOrNull_impl_1asnfp(it.uex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_9 = 'periodStartTime';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_20 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_21 = serializer(this_20, createKType(getKClass(Instant()), arrayOf([]), true));
  var tmp$ret$31 = isInterface(this_21, KSerializer()) ? this_21 : THROW_CCE();
  encodeToStringMap(tmp0_9, tmp$ret$31, tmp2_9, key_9, p);
  var tmp0_10 = get_UrlProperties();
  var tmp2_10 = ReactiveState__getOrNull_impl_1asnfp(it.xex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_10 = 'periodAllowedContractors';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_22 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_23 = serializer(this_22, createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(UUID()), arrayOf([]), false))]), true));
  var tmp$ret$34 = isInterface(this_23, KSerializer()) ? this_23 : THROW_CCE();
  encodeToStringMap(tmp0_10, tmp$ret$34, tmp2_10, key_10, p);
  var tmp0_11 = get_UrlProperties();
  var tmp2_11 = ReactiveState__getOrNull_impl_1asnfp(it.zex_1.sah());
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var key_11 = 'homeownerAt';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_24 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_25 = serializer(this_24, createKType(getKClass(Instant()), arrayOf([]), true));
  var tmp$ret$37 = isInterface(this_25, KSerializer()) ? this_25 : THROW_CCE();
  encodeToStringMap(tmp0_11, tmp$ret$37, tmp2_11, key_11, p);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['admin', 'reports']), p), listOf([it.yex_1, it.rex_1, it.pex_1, it.cey_1, it.aey_1, it.wex_1, it.vex_1, it.oex_1, it.qex_1, it.bey_1, it.uex_1, it.xex_1, it.zex_1]));
}
function AutoRoutes$lambda_76(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof DevProjectView()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var value = ReactiveState__getOrNull_impl_1asnfp(it.key_1.sah());
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(WorkSection()), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, value, 'tab', p);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.hey_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['dev-project', tmp$ret$5]), p), listOf_0(it.key_1));
}
function AutoRoutes$lambda_77(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof SelectDevProjectScreen()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf_0('select-dev-project'), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_78(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof FourOhFour()))
    return null;
  var p = HashMap().n8();
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  var tmp = new (UrlLikePath())(tmp$ret$0, p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$1 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$1);
}
function AutoRoutes$lambda_79(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ProjectRouter()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var value = ReactiveState__getOrNull_impl_1asnfp(it.tez_1.sah());
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(JumpTo()), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, value, 'jumpto', p);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.sez_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['projects', tmp$ret$5]), p), listOf_0(it.tez_1));
}
function AutoRoutes$lambda_80(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof MessagingScreen()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.of8_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(ProjectLens()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = encodeToString(tmp0, tmp$ret$1, value);
  var tmp = new (UrlLikePath())(listOf(['messages', tmp$ret$2]), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$3 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$3);
}
function AutoRoutes$lambda_81(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorWorkLists()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'tasks']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_82(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ClientWorkLists()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['client', 'tasks']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_83(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof LandingScreen()))
    return null;
  var p = HashMap().n8();
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  var tmp = new (UrlLikePath())(tmp$ret$0, p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$1 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$1);
}
function AutoRoutes$lambda_84(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ClientNotificationSettings()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['client', 'notifications']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_85(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ContractorNotificationSettings()))
    return null;
  var p = HashMap().n8();
  var tmp = new (UrlLikePath())(listOf(['contractor', 'notifications']), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$0);
}
function AutoRoutes$lambda_86(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof AnonymousProjectView()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToStringMap' call
  var value = ReactiveState__getOrNull_impl_1asnfp(it.mf1_1.sah());
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = get_UrlProperties().mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), true));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  encodeToStringMap(tmp0, tmp$ret$1, value, 'server', p);
  var tmp0_0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value_0 = it.kf1_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0_0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(UUID()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$5 = encodeToString(tmp0_0, tmp$ret$4, value_0);
  return new (RouteRendered())(new (UrlLikePath())(listOf(['anonymous', 'projects', tmp$ret$5]), p), listOf_0(it.mf1_1));
}
function AutoRoutes$lambda_87(it) {
  _init_properties_autoroutes_kt__az6i9l();
  if (!(it instanceof ViewLegalDocument()))
    return null;
  var p = HashMap().n8();
  var tmp0 = get_UrlProperties();
  // Inline function 'com.lightningkite.kiteui.navigation.encodeToString' call
  var value = it.rf8_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(getKClass(Type()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var tmp$ret$2 = encodeToString(tmp0, tmp$ret$1, value);
  var tmp = new (UrlLikePath())(listOf(['documents', tmp$ret$2]), p);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$3 = emptyList();
  return new (RouteRendered())(tmp, tmp$ret$3);
}
var properties_initialized_autoroutes_kt_ejo6rf;
function _init_properties_autoroutes_kt__az6i9l() {
  if (!properties_initialized_autoroutes_kt_ejo6rf) {
    properties_initialized_autoroutes_kt_ejo6rf = true;
    var tmp = AutoRoutes$lambda;
    var tmp_0 = AutoRoutes$lambda_0;
    var tmp_1 = AutoRoutes$lambda_1;
    var tmp_2 = AutoRoutes$lambda_2;
    var tmp_3 = AutoRoutes$lambda_3;
    var tmp_4 = AutoRoutes$lambda_4;
    var tmp_5 = AutoRoutes$lambda_5;
    var tmp_6 = AutoRoutes$lambda_6;
    var tmp_7 = AutoRoutes$lambda_7;
    var tmp_8 = AutoRoutes$lambda_8;
    var tmp_9 = AutoRoutes$lambda_9;
    var tmp_10 = AutoRoutes$lambda_10;
    var tmp_11 = AutoRoutes$lambda_11;
    var tmp_12 = AutoRoutes$lambda_12;
    var tmp_13 = AutoRoutes$lambda_13;
    var tmp_14 = AutoRoutes$lambda_14;
    var tmp_15 = AutoRoutes$lambda_15;
    var tmp_16 = AutoRoutes$lambda_16;
    var tmp_17 = AutoRoutes$lambda_17;
    var tmp_18 = AutoRoutes$lambda_18;
    var tmp_19 = AutoRoutes$lambda_19;
    var tmp_20 = AutoRoutes$lambda_20;
    var tmp_21 = AutoRoutes$lambda_21;
    var tmp_22 = AutoRoutes$lambda_22;
    var tmp_23 = AutoRoutes$lambda_23;
    var tmp_24 = AutoRoutes$lambda_24;
    var tmp_25 = AutoRoutes$lambda_25;
    var tmp_26 = AutoRoutes$lambda_26;
    var tmp_27 = AutoRoutes$lambda_27;
    var tmp_28 = AutoRoutes$lambda_28;
    var tmp_29 = AutoRoutes$lambda_29;
    var tmp_30 = AutoRoutes$lambda_30;
    var tmp_31 = AutoRoutes$lambda_31;
    var tmp_32 = AutoRoutes$lambda_32;
    var tmp_33 = AutoRoutes$lambda_33;
    var tmp_34 = AutoRoutes$lambda_34;
    var tmp_35 = AutoRoutes$lambda_35;
    var tmp_36 = AutoRoutes$lambda_36;
    var tmp_37 = AutoRoutes$lambda_37;
    var tmp_38 = AutoRoutes$lambda_38;
    var tmp_39 = AutoRoutes$lambda_39;
    var tmp_40 = AutoRoutes$lambda_40;
    var tmp_41 = AutoRoutes$lambda_41;
    var tmp_42 = listOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, AutoRoutes$lambda_42]);
    var tmp_43 = getKClass(PayAppForm());
    var tmp_44 = to(tmp_43, AutoRoutes$lambda_43);
    var tmp_45 = getKClass(PayAppDetails());
    var tmp_46 = to(tmp_45, AutoRoutes$lambda_44);
    var tmp_47 = getKClass(ChangeOrderForm2());
    var tmp_48 = to(tmp_47, AutoRoutes$lambda_45);
    var tmp_49 = getKClass(ChangeOrderDetails());
    var tmp_50 = to(tmp_49, AutoRoutes$lambda_46);
    var tmp_51 = getKClass(ScopeViewDetails());
    var tmp_52 = to(tmp_51, AutoRoutes$lambda_47);
    var tmp_53 = getKClass(LineItemDetailsPage());
    var tmp_54 = to(tmp_53, AutoRoutes$lambda_48);
    var tmp_55 = getKClass(ProjectMessageThread());
    var tmp_56 = to(tmp_55, AutoRoutes$lambda_49);
    var tmp_57 = getKClass(ViewSettlementDocs());
    var tmp_58 = to(tmp_57, AutoRoutes$lambda_50);
    var tmp_59 = getKClass(CreateProjectForm());
    var tmp_60 = to(tmp_59, AutoRoutes$lambda_51);
    var tmp_61 = getKClass(ManageContractorUsers());
    var tmp_62 = to(tmp_61, AutoRoutes$lambda_52);
    var tmp_63 = getKClass(ContractorProjects());
    var tmp_64 = to(tmp_63, AutoRoutes$lambda_53);
    var tmp_65 = getKClass(EditProject());
    var tmp_66 = to(tmp_65, AutoRoutes$lambda_54);
    var tmp_67 = getKClass(ContractorPayments());
    var tmp_68 = to(tmp_67, AutoRoutes$lambda_55);
    var tmp_69 = getKClass(CreateProject());
    var tmp_70 = to(tmp_69, AutoRoutes$lambda_56);
    var tmp_71 = getKClass(ContractorProject());
    var tmp_72 = to(tmp_71, AutoRoutes$lambda_57);
    var tmp_73 = getKClass(Specifications());
    var tmp_74 = to(tmp_73, AutoRoutes$lambda_58);
    var tmp_75 = getKClass(ContractorDashboard());
    var tmp_76 = to(tmp_75, AutoRoutes$lambda_59);
    var tmp_77 = getKClass(ContractorClients());
    var tmp_78 = to(tmp_77, AutoRoutes$lambda_60);
    var tmp_79 = getKClass(ContractorProfile());
    var tmp_80 = to(tmp_79, AutoRoutes$lambda_61);
    var tmp_81 = getKClass(ContractorBillingInfo());
    var tmp_82 = to(tmp_81, AutoRoutes$lambda_62);
    var tmp_83 = getKClass(ContractorBankInfo());
    var tmp_84 = to(tmp_83, AutoRoutes$lambda_63);
    var tmp_85 = getKClass(ContractorNewRegistration());
    var tmp_86 = to(tmp_85, AutoRoutes$lambda_64);
    var tmp_87 = getKClass(LogInScreen());
    var tmp_88 = to(tmp_87, AutoRoutes$lambda_65);
    var tmp_89 = getKClass(UserRegistration());
    var tmp_90 = to(tmp_89, AutoRoutes$lambda_66);
    var tmp_91 = getKClass(PaymentSetup());
    var tmp_92 = to(tmp_91, AutoRoutes$lambda_67);
    var tmp_93 = getKClass(UserProfile());
    var tmp_94 = to(tmp_93, AutoRoutes$lambda_68);
    var tmp_95 = getKClass(ClientPayments());
    var tmp_96 = to(tmp_95, AutoRoutes$lambda_69);
    var tmp_97 = getKClass(ClientProject());
    var tmp_98 = to(tmp_97, AutoRoutes$lambda_70);
    var tmp_99 = getKClass(ClientProjects());
    var tmp_100 = to(tmp_99, AutoRoutes$lambda_71);
    var tmp_101 = getKClass(ClientTermsAndServices());
    var tmp_102 = to(tmp_101, AutoRoutes$lambda_72);
    var tmp_103 = getKClass(ClientDashboard());
    var tmp_104 = to(tmp_103, AutoRoutes$lambda_73);
    var tmp_105 = getKClass(AdminExternalDepositPage());
    var tmp_106 = to(tmp_105, AutoRoutes$lambda_74);
    var tmp_107 = getKClass(AdminReportingPage());
    var tmp_108 = to(tmp_107, AutoRoutes$lambda_75);
    var tmp_109 = getKClass(DevProjectView());
    var tmp_110 = to(tmp_109, AutoRoutes$lambda_76);
    var tmp_111 = getKClass(SelectDevProjectScreen());
    var tmp_112 = to(tmp_111, AutoRoutes$lambda_77);
    var tmp_113 = getKClass(FourOhFour());
    var tmp_114 = to(tmp_113, AutoRoutes$lambda_78);
    var tmp_115 = getKClass(ProjectRouter());
    var tmp_116 = to(tmp_115, AutoRoutes$lambda_79);
    var tmp_117 = getKClass(MessagingScreen());
    var tmp_118 = to(tmp_117, AutoRoutes$lambda_80);
    var tmp_119 = getKClass(ContractorWorkLists());
    var tmp_120 = to(tmp_119, AutoRoutes$lambda_81);
    var tmp_121 = getKClass(ClientWorkLists());
    var tmp_122 = to(tmp_121, AutoRoutes$lambda_82);
    var tmp_123 = getKClass(LandingScreen());
    var tmp_124 = to(tmp_123, AutoRoutes$lambda_83);
    var tmp_125 = getKClass(ClientNotificationSettings());
    var tmp_126 = to(tmp_125, AutoRoutes$lambda_84);
    var tmp_127 = getKClass(ContractorNotificationSettings());
    var tmp_128 = to(tmp_127, AutoRoutes$lambda_85);
    var tmp_129 = getKClass(AnonymousProjectView());
    var tmp_130 = to(tmp_129, AutoRoutes$lambda_86);
    var tmp_131 = getKClass(ViewLegalDocument());
    AutoRoutes = new (Routes())(tmp_42, mapOf([tmp_44, tmp_46, tmp_48, tmp_50, tmp_52, tmp_54, tmp_56, tmp_58, tmp_60, tmp_62, tmp_64, tmp_66, tmp_68, tmp_70, tmp_72, tmp_74, tmp_76, tmp_78, tmp_80, tmp_82, tmp_84, tmp_86, tmp_88, tmp_90, tmp_92, tmp_94, tmp_96, tmp_98, tmp_100, tmp_102, tmp_104, tmp_106, tmp_108, tmp_110, tmp_112, tmp_114, tmp_116, tmp_118, tmp_120, tmp_122, tmp_124, tmp_126, tmp_128, tmp_130, to(tmp_131, AutoRoutes$lambda_87)]), FourOhFour_instance);
  }
}
//region block: exports
export {
  get_AutoRoutes as get_AutoRoutes3nqqi7p59slz8,
};
//endregion

//# sourceMappingURL=autoroutes.mjs.map
